import { NgModule } from '@angular/core';

import {
    MatCardModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatDividerModule,
    MatToolbarModule,
    MatMenuModule,
    MatTooltipModule
} from '@angular/material';
//Angular Material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import {MatFormFieldModule} from '@angular/material/form-field';
// import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
// import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
    
    imports: [
        MatButtonModule,
        MatTableModule,
        MatDividerModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatExpansionModule,
        MatListModule,
        MatTooltipModule,
        MatDialogModule,
        // MatBottomSheet, MatBottomSheetRef
    ],
    exports: [
        MatButtonModule,
        MatTableModule,
        MatDividerModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatExpansionModule,
        MatListModule,
        MatFormFieldModule,
        // MatBottomSheet, MatBottomSheetRef
    ]
})
export class MaterialModule { }